export const Footer = () => <div style={{ marginBottom: '36px' }}></div>
